const normalize = (s?: string) => (s || "").toLowerCase().trim();
const stripNonDigits = (s?: string) => (s || "").replace(/\D/g, "");

function removeNameTitles(fullName: string | undefined) {
    // 1. Handle empty or null/undefined-like input
    if (!fullName) {
        return "";
    }

    // 2. Define the titles to check against (case-insensitive in the check)
    const titles: string[] = ["ms", "mr", "mrs", "mss", "miss", "dr", "prof", "sir", "madam"];

    // 3. Split the name into parts, after trimming leading/trailing whitespace
    const parts: string[] = fullName.trim().split(/\s+/); // Use regex to handle multiple spaces

    // 4. Handle case where trimming/splitting results in no parts (e.g., just whitespace)
    if (parts.length === 0) {
        return fullName; // Though `fullName.trim()` would be an empty string, we return the original as in the Python logic
    }

    // 5. Get the first part, convert to lowercase, and remove any trailing period ('.')
    let firstPart: string = parts[0].toLowerCase();

    // The Python rstrip('.') is equivalent to removing the last character if it's a '.'
    if (firstPart.endsWith(".")) {
        firstPart = firstPart.slice(0, -1);
    }

    // 6. Check if the processed first part is in the list of titles
    if (titles.includes(firstPart)) {
        // If it's a title, join the rest of the parts back into a string
        return parts.slice(1).join(" ");
    }

    // 7. If no title was found, return the original full name
    return fullName;
}

function parseNameParts(fullName: string | undefined): string {
    // Note: This relies on the TypeScript implementation of removeNameTitles
    // being available in the same scope or imported.
    const cleanName: string = removeNameTitles(fullName);

    // Use regex to split by one or more whitespace characters
    const parts: string[] = cleanName.trim().split(/\s+/);

    // Handle case where cleanName might be empty or only whitespace
    if (parts.length === 0 || (parts.length === 1 && parts[0] === "")) {
        return "";
    }

    if (parts.length === 1) {
        // Example: "Chloe" -> ["Chloe", ""]
        return parts[0];
    } else {
        // Example: "Chloe Lee" -> ["Chloe", "Lee"]
        // Example: "Chloe Sun Lee" -> ["Chloe", "Lee"]
        return parts[0];
    }
}

function titleCase(input: string): string {
    if (!input) return input;
    const lower = input.toLowerCase();
    const cap = (s: string) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
    return lower
        .split(" ")
        .map((word) =>
            word
                .split("-")
                .map((p) => p.split("'").map(cap).join("'"))
                .join("-")
        )
        .join(" ");
}

export { normalize, stripNonDigits, parseNameParts, titleCase };
